<nz-alert
	*ngIf="ticket && !ticket.hasAccess"
	nzType="warning"
	nzMessage="Read Only"
	nzDescription="You don't have permissions to process this ticket."
	nzShowIcon
	class="mb-3">
</nz-alert>

<nz-alert
	*ngIf="ticket && ticket.hasAccess && !ticket.questionnaireEditable"
	nzType="warning"
	nzMessage="Read Only"
	[nzDescription]="`Questionnaire cannot be edited while on: ${ticket.currentStepAndStateLabel}`"
	nzShowIcon
	class="mb-3">
</nz-alert>
<h4>Progress</h4>

<div class="progress position-relative" role="progressbar">
	<div class="progress-bar text-bg-info" [style]="'width: ' + questionnaire!.progress + '%'"></div>
	<span class="position-absolute top-50 start-50 translate-middle w-100 text-center">
		{{questionnaire!.progress}}%
	</span>
</div>
<div class="row mt-3" *ngIf="questionnaire!.id <= 0">
	<div class="col">
		<nz-form-item>
				Questionnaire name
				<input nz-input [(ngModel)]="questionnaire!.name"/>
		</nz-form-item>
	</div>
</div>

<app-dft-card *ngFor="let section of questionnaire!.step!.sections"
	[title]="section.label"
	[readonly]="!ticket.hasAccess || !ticket.questionnaireEditable"
	[dynamicForm]="dynamicForms![section.id]"
	[allFormControls]="allFormControls"
	[allForms]="allForms"
	[masterForm]="masterForm">
</app-dft-card>

<div class="row">
	<div class="col">
		<button nz-button nzType="dashed" *ngIf="ticket.questionnaireEditable && questionnaire!.id <= 0" (click)="save()">Add</button>
		<button nz-button nzType="dashed" *ngIf="ticket.questionnaireEditable && questionnaire!.id > 0" (click)="save()">Save</button>
		<button nz-button nzType="dashed" (click)="cancel()">Cancel</button>
	</div>
</div>
